import React, { useEffect, useState } from 'react';
import { client } from '../../client';
import { AiFillDelete } from 'react-icons/ai';
import toast from 'react-hot-toast';

export default function Pins() {
  const [pins, setPins] = useState([]);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "pin"]{_id, title, image{asset->{url}}, postedBy->{userName}}`
      )
      .then((data) => setPins(data));
  }, []);

  const deletePin = async (id) => {
    try {
      await client
        .patch(id)
        .set({ status: 'removed', adminReason: 'This post was deleted by admin.' })
        .commit();

      toast.success('Pin marked as removed (user notified)');
      setPins((prev) => prev.filter((p) => p._id !== id));
    } catch (error) {
      console.error('Error deleting pin:', error);
      toast.error('Failed to delete pin');
    }
  };

  return (
    <div>
      <h2 className="text-3xl font-extrabold mb-10 text-gray-900 dark:text-white text-center tracking-tight drop-shadow-lg">
        All Posts
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
        {pins.map((pin) => (
          <div
            key={pin._id}
            className="relative rounded-3xl overflow-hidden shadow-xl bg-gradient-to-br from-gray-800 via-gray-900 to-slate-900 dark:from-gray-900 dark:via-gray-800 dark:to-slate-900 backdrop-blur-xl border border-white/20 dark:border-gray-700/60 transition-transform duration-300 hover:scale-105 hover:shadow-2xl group"
          >
            {/* Gradient border effect */}
            <div className="absolute inset-0 z-0 pointer-events-none rounded-3xl bg-gradient-to-tr from-blue-400 via-teal-300 to-purple-400 opacity-40 blur-[2px]" />

            <div className="relative z-10 flex flex-col h-full">
              <img
                src={pin.image.asset.url}
                alt={pin.title}
                className="w-full h-48 object-cover rounded-t-3xl border-b-2 border-white/10"
              />

              <div className="flex-1 p-5 flex flex-col justify-between">
                <h3 className="text-lg font-bold text-white truncate mb-2 drop-shadow">
                  {pin.title}
                </h3>
                <p className="text-sm text-cyan-200 mb-4">
                  <span className="font-semibold">By:</span> {pin.postedBy.userName}
                </p>
                <button
                  onClick={() => deletePin(pin._id)}
                  className="flex items-center justify-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-red-500 to-pink-500 text-white font-semibold shadow-md hover:scale-105 hover:from-red-600 hover:to-pink-600 transition-all duration-200"
                >
                  <AiFillDelete className="text-lg" />
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
